/* Robols: sugerencias del carrito lateral.
   El cajón viene dibujado desde el servidor; esto solo agrega los decants sugeridos cuando al
   carrito le falta para el envío gratis. Se preparan al abrir el carrito (no en cada página que
   se visita), se quedan en su lugar cuando el carrito se redibuja, leen los perfumes del propio
   cajón sin volver a pedir el carrito en cada cambio, y se guardan mientras dura la visita. */
(function () {
  if (window.robolsCarritoListo) return;
  window.robolsCarritoListo = true;

  var CFG = document.getElementById('RobolsCarritoCfg');
  var RUTA_AGREGAR = (CFG && CFG.dataset.agregar) || '/cart/add';
  var RAIZ = (CFG && CFG.dataset.raiz) || '/';
  var FORMATO = (CFG && CFG.dataset.formato) || '${{amount}}';
  var TIPOS = ['Extrait de Parfum', 'Extrait De Parfum', 'Eau de Parfum', 'Eau De Parfum', 'Eau de parfum',
    'Eau de Toilette', 'Eau De Toilette', 'Eau de Cologne', 'Absolu de Parfum', ' EDP', ' EDT'];
  var cache = {};
  var firma = '';
  var ultimo = '';

  function sinAcentos(t) {
    return t.replace(/á/g, 'a').replace(/é/g, 'e').replace(/è/g, 'e').replace(/í/g, 'i')
      .replace(/ó/g, 'o').replace(/ú/g, 'u').replace(/ñ/g, 'n');
  }
  function nombreLimpio(titulo, marca) {
    if (window.rcNombre) return window.rcNombre(titulo, marca);
    var n = (titulo || '').replace(/\(Preventa\)/gi, '').replace(/[®™]/g, '');
    if (marca) {
      [marca, marca.toUpperCase(), sinAcentos(marca), marca.replace(/ /g, '-')].forEach(function (m) {
        if (m) n = n.split(m).join('');
      });
      var primera = marca.split(' ')[0];
      n = n.split(' By ' + primera).join('').split(' by ' + primera).join('');
    }
    TIPOS.forEach(function (t) { n = n.split(t).join(''); });
    n = n.replace(/\s\d{2,3}\s?ml/gi, '').replace(/\s{2,}/g, ' ').trim();
    n = n.replace(/\sParfum$/, '').replace(/\sExtrait$/, '').replace(/\s(by|de)$/i, '');
    n = n.replace(/^[-–,]\s*/, '').replace(/\s*[-–,]$/, '').trim();
    return n.length < 2 ? (titulo || '') : n;
  }
  function dinero(centavos) {
    var v = (centavos / 100).toFixed(2).replace(/\.00$/, '').replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return FORMATO.replace(/\{\{\s*amount[^}]*\}\}/, v).replace(/\s?MXN/, '').replace('$ ', '$');
  }
  // Los precios llegan en centavos desde las recomendaciones y en pesos desde products.json
  function centavos(precio) {
    if (typeof precio === 'string') return Math.round(parseFloat(precio) * 100);
    return precio;
  }
  function foto(p) {
    var f = p.featured_image;
    if (!f && p.images && p.images.length) f = typeof p.images[0] === 'string' ? p.images[0] : p.images[0].src;
    if (!f) return '';
    return f + (f.indexOf('?') >= 0 ? '&' : '?') + 'width=300';
  }
  function decant(p) {
    var v = (p.variants || []).filter(function (x) {
      return x.available !== false && /decant/i.test(x.title) && !/preventa/i.test(x.title);
    });
    v.sort(function (a, b) { return centavos(a.price) - centavos(b.price); });
    return v[0];
  }
  function tarjeta(p, variante) {
    var ml = variante.title.replace(/decants?/i, '').trim();
    return '<div class="rc-sug__card" data-producto="' + p.id + '">' +
      '<a href="' + RAIZ + 'products/' + p.handle + '" tabindex="-1"><img class="rc-sug__foto" src="' + foto(p) + '" alt=""></a>' +
      '<span class="rc-sug__nombre">' + nombreLimpio(p.title, p.vendor) + '</span>' +
      '<span class="rc-sug__precio">' + ml + ' · <strong>' + dinero(centavos(variante.price)) + '</strong></span>' +
      '<button type="button" class="rc-sug__btn" data-id="' + variante.id + '" data-producto="' + p.id + '" data-marca="' + attr(p.vendor) +
      '" data-nombre="' + attr(nombreLimpio(p.title, p.vendor)) + '" data-tamano="' + attr(variante.title) + '" data-precio="' + centavos(variante.price) + '" data-antes="' + (centavos(variante.compare_at_price) || 0) + '">' +
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg>AGREGAR</button></div>';
  }
  // Solo lo necesario de cada perfume, para guardar poco
  function ligero(p) {
    return {
      id: p.id, title: p.title, vendor: p.vendor, handle: p.handle, featured_image: foto(p).replace(/[?&]width=300$/, ''),
      variants: (p.variants || []).map(function (v) { return { id: v.id, title: v.title, price: v.price, compare_at_price: v.compare_at_price, available: v.available }; })
    };
  }
  // Las fotos ya cargadas se guardan y se vuelven a poner tal cual cuando las sugerencias se redibujan
  var fotosListas = {};
  function reusarFotos(caja) {
    caja.querySelectorAll('img.rc-sug__foto').forEach(function (i) {
      var src = i.getAttribute('src'), lista = fotosListas[src] || (fotosListas[src] = []), previa = null;
      for (var k = 0; k < lista.length; k++) if (lista[k] !== i && !lista[k].isConnected) { previa = lista[k]; break; }
      if (previa) i.replaceWith(previa);
      else if (lista.indexOf(i) === -1) lista.push(i);
    });
  }
  function attr(t) { return String(t || '').replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;'); }
  function cajon() { return document.querySelector('cart-drawer'); }
  function abierto() { var c = cajon(); return !!(c && c.classList.contains('active')); }
  function menosMovimiento() { return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches); }
  // Mientras llegan las sugerencias, su lugar queda apartado con siluetas del mismo tamaño: así nada brinca al llegar
  function esqueleto() {
    var t = '<div class="rc-sug__card rc-sug__card--hueco" aria-hidden="true"><span class="rc-sug__foto rc-sug__foto--hueco"></span>' +
      '<span class="rc-sug__nombre">&#160;</span><span class="rc-sug__precio">&#160;</span>' +
      '<span class="rc-sug__btn rc-sug__btn--hueco"></span></div>';
    return '<div class="rc-sug__encabezado"><p class="rc-sug__titulo">COMPLETA TU ENVÍO GRATIS</p>' +
      '<a class="rc-sug__todos" href="' + RAIZ + 'collections/decants">VER TODOS' +
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 5l7 7-7 7"/></svg></a></div>' +
      '<div class="rc-sug__fila">' + t + t + t + '</div>';
  }
  // Estilos de lo nuevo (siluetas y desvanecidos), en un solo lugar
  (function () {
    var e = document.createElement('style');
    e.textContent = '.rc-sugeridos .rc-sug__foto{background:#262626}' +
      '.rc-sug__foto--hueco{border-radius:.6rem}' +
      '.rc-sug__card--hueco .rc-sug__nombre,.rc-sug__card--hueco .rc-sug__precio{color:transparent;background:linear-gradient(#262626,#262626) center/70% .9em no-repeat}' +
      '.rc-sug__card--hueco .rc-sug__precio{background-size:45% .9em}' +
      '.rc-sug__btn--hueco{border-color:#262626}' +
      // Loox les pone visibility: visible a todas las partes de su ventanita, así que esconder solo la caja no basta: la
      // foto y las estrellas (que no llevan clase) se seguían viendo encima del carrito, sin su botón de cerrar
      'body.rc-carrito-abierto .loox-pn,body.rc-carrito-abierto .loox-pn *,body.rc-carrito-abierto [class*="loox-pn"]{visibility:hidden!important;pointer-events:none!important}';
    document.head.appendChild(e);
  })();

  // Lo que hay en el cajón: cuánto falta y qué perfumes lleva. La base de las sugerencias es el perfume más antiguo
  // (el primer renglón): así no cambian todas cada vez que se agrega algo
  function leerCajon() {
    var caja = document.querySelector('[data-rc-sugeridos]');
    if (!caja) return null;
    var filas = [].filter.call(document.querySelectorAll('cart-drawer .rc-item[data-producto]'), function (f) {
      return !f.classList.contains('rc-item--saliendo');
    });
    var dentro = filas.map(function (f) { return parseInt(f.getAttribute('data-producto'), 10); });
    return {
      caja: caja,
      falta: parseInt(caja.getAttribute('data-falta'), 10) || 0,
      dentro: dentro,
      base: dentro.length ? dentro[0] : 0
    };
  }

  // Si el cajón se redibujó, las sugerencias vuelven en el mismo instante (sin las que ya se agregaron)
  function reponer() {
    var d = leerCajon();
    if (!d) return;
    if (d.falta <= 0 || !d.base) {
      if (d.caja.innerHTML) cerrarSugerencias(d.caja);
      return;
    }
    // Vuelve a faltar para el envío gratis mientras se estaban cerrando: se quedan como estaban
    if (d.caja.rcCerrando) soltarCierre(d.caja);
    if (d.caja.children.length || !ultimo) return;
    d.caja.innerHTML = ultimo;
    reusarFotos(d.caja);
    d.caja.querySelectorAll('.rc-sug__card').forEach(function (t) {
      if (d.dentro.indexOf(parseInt(t.getAttribute('data-producto'), 10)) !== -1) t.remove();
    });
  }

  // Al llegar al envío gratis las sugerencias se cierran suave (antes se borraban de golpe y la lista brincaba).
  // Con el carrito cerrado, o si el cliente pidió menos movimiento en su teléfono, se quitan al instante como antes
  function cerrarSugerencias(caja) {
    if (caja.rcCerrando) return;
    var alto = caja.offsetHeight, menos = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!alto || !abierto() || menos) { caja.innerHTML = ''; return; }
    caja.rcCerrando = true;
    caja.style.height = alto + 'px';
    caja.style.overflow = 'hidden';
    void caja.offsetHeight;
    caja.style.transition = 'height .28s ease, padding .28s ease, margin .28s ease, border-width .28s ease, opacity .16s ease';
    caja.style.height = '0px';
    caja.style.paddingTop = '0px';
    caja.style.paddingBottom = '0px';
    caja.style.marginTop = '0px';
    caja.style.borderTopWidth = '0px';
    caja.style.opacity = '0';
    caja.rcReloj = setTimeout(function () {
      var d = leerCajon();
      soltarCierre(caja);
      if (!d || d.caja !== caja || d.falta <= 0 || !d.base) caja.innerHTML = '';
    }, 300);
  }
  function soltarCierre(caja) {
    clearTimeout(caja.rcReloj);
    caja.rcCerrando = false;
    caja.removeAttribute('style');
  }

  // Una foto ya está lista si alguna copia guardada terminó de cargar
  function fotoLista(src) {
    return (fotosListas[src] || []).some(function (i) { return i.complete && i.naturalWidth > 0; });
  }
  function precargar(src) {
    var pre = new Image();
    pre.setAttribute('class', 'rc-sug__foto'); pre.setAttribute('src', src); pre.setAttribute('alt', '');
    (fotosListas[src] = fotosListas[src] || []).push(pre);
    return pre;
  }
  var turno = 0;
  function dibuja(lista, dentro) {
    var d = leerCajon();
    if (!d) return;
    // Cada perfume una sola vez (las recomendaciones y Más vendido pueden traer el mismo)
    var usables = [], fotos = [], siguientes = 0, vistos = {};
    lista.forEach(function (p) {
      if (vistos[p.id] || dentro.indexOf(p.id) !== -1) return;
      var v = decant(p);
      if (!v) return;
      vistos[p.id] = true;
      if (usables.length < 3) { usables.push(tarjeta(p, v)); fotos.push(foto(p)); }
      else if (siguientes < 3) {
        // Las fotos de las que entrarían después se piden de una vez: si agregas una, la siguiente aparece con foto
        siguientes++;
        if (!fotosListas[foto(p)]) precargar(foto(p));
      }
    });
    ultimo = !usables.length ? '' :
      '<div class="rc-sug__encabezado"><p class="rc-sug__titulo">COMPLETA TU ENVÍO GRATIS</p>' +
      '<a class="rc-sug__todos" href="' + RAIZ + 'collections/decants">VER TODOS' +
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 5l7 7-7 7"/></svg></a></div>' +
      '<div class="rc-sug__fila">' + usables.join('') + '</div>';
    if (d.caja.innerHTML === ultimo) return;
    var mio = ++turno, html = ultimo;
    function poner() {
      var c2 = leerCajon();
      if (mio !== turno || !c2 || c2.caja.innerHTML === html) return;
      var caja = c2.caja, suave = abierto() && !menosMovimiento();
      var antes = [].map.call(caja.querySelectorAll('.rc-sug__card:not(.rc-sug__card--hueco)'), function (t) { return t.getAttribute('data-producto'); });
      var molde = document.createElement('div');
      molde.innerHTML = html;
      var nuevas = [].filter.call(molde.querySelectorAll('.rc-sug__card'), function (t) {
        return c2.dentro.indexOf(parseInt(t.getAttribute('data-producto'), 10)) === -1;
      });
      var ids = nuevas.map(function (t) { return t.getAttribute('data-producto'); });
      // Las que se quedan conservan su lugar; las nuevas ocupan los lugares que se liberaron
      var orden = antes.map(function (id) { return ids.indexOf(id) !== -1 ? id : null; }), libres = ids.filter(function (id) { return orden.indexOf(id) === -1; });
      orden = orden.map(function (id) { return id || libres.shift() || null; }).filter(Boolean).concat(libres);
      var fila = molde.querySelector('.rc-sug__fila');
      if (fila) {
        while (fila.firstChild) fila.removeChild(fila.firstChild);
        orden.forEach(function (id) { nuevas.forEach(function (t) { if (t.getAttribute('data-producto') === id) fila.appendChild(t); }); });
      }
      var salen = [].filter.call(caja.querySelectorAll('.rc-sug__card:not(.rc-sug__card--hueco)'), function (t) { return ids.indexOf(t.getAttribute('data-producto')) === -1; });
      function cambiar() {
        if (mio !== turno || !caja.isConnected) return;
        var habia = antes.length > 0, filaA = caja.querySelector('.rc-sug__fila'), filaN = molde.querySelector('.rc-sug__fila'), entran = [];
        if (habia && filaA && filaN && !caja.querySelector('.rc-sug__card--hueco')) {
          // Solo se cambian las tarjetas que cambian: las demás (y sus botones) se quedan, así ningún toque se pierde
          var viejas = [].slice.call(filaA.querySelectorAll('.rc-sug__card')), quedan = [].slice.call(filaN.children);
          quedan.forEach(function (t, i) {
            var v = viejas[i];
            if (v && v.getAttribute('data-producto') === t.getAttribute('data-producto')) return;
            if (v) filaA.replaceChild(t, v); else filaA.appendChild(t);
            entran.push(t);
          });
          viejas.slice(quedan.length).forEach(function (v) { if (v.parentNode) v.remove(); });
        } else {
          caja.innerHTML = molde.innerHTML;
          entran = [].slice.call(caja.querySelectorAll('.rc-sug__card'));
        }
        reusarFotos(caja);
        if (!suave) return;
        var i = 0;
        entran.forEach(function (t) {
          if (t.animate) t.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 180, delay: habia ? 0 : 60 * i++, easing: 'ease-out', fill: 'backwards' });
        });
      }
      if (suave && salen.length && antes.length) {
        salen.forEach(function (t) { t.style.transition = 'opacity .12s ease'; t.style.opacity = '0'; });
        setTimeout(cambiar, 120);
      } else cambiar();
    }
    // Si ya se ven sugerencias y llegan otras con fotos que no han cargado, las de ahora se quedan hasta que las nuevas
    // estén listas (máximo 1.5 s): así nunca se ven cuadros negros al cambiar
    var nuevas = fotos.filter(function (src) { return src && !fotoLista(src); });
    if (!nuevas.length || !d.caja.children.length) return poner();
    d.caja.querySelectorAll('.rc-sug__card').forEach(function (t) {
      var b = t.querySelector('.rc-sug__btn');
      if (b && d.dentro.indexOf(parseInt(t.getAttribute('data-producto'), 10)) !== -1) b.disabled = true;
    });
    var faltan = nuevas.length, hecho = false;
    function una() { if (--faltan <= 0 && !hecho) { hecho = true; poner(); } }
    nuevas.forEach(function (src) {
      var pre = (fotosListas[src] || []).filter(function (i) { return !i.isConnected; })[0] || precargar(src);
      if (pre.complete && pre.naturalWidth > 0) una();
      else { pre.addEventListener('load', una); pre.addEventListener('error', una); }
    });
    setTimeout(function () { if (!hecho) { hecho = true; poner(); } }, 1500);
  }

  function pintar(aunCerrado) {
    reponer();
    var d = leerCajon();
    if (!d || d.falta <= 0 || !d.base) { firma = ''; return; }
    if (!aunCerrado && !abierto()) return;
    var nueva = d.base + '|' + d.dentro.join(',');
    if (nueva === firma && d.caja.children.length) return;
    firma = nueva;
    if (!cache[d.base]) {
      try { cache[d.base] = JSON.parse(sessionStorage.getItem('rc-sug2:' + d.base) || 'null'); } catch (e) {}
    }
    if (cache[d.base]) { dibuja(cache[d.base], d.dentro); return; }
    var base = d.base, dentro = d.dentro;
    if (!d.caja.children.length) d.caja.innerHTML = esqueleto();
    // Las dos listas se piden al mismo tiempo (antes una después de la otra): llegan antes
    var masVendido = fetch(RAIZ + 'collections/mas-vendido/products.json?limit=16')
      .then(function (r) { return r.json(); })
      .then(function (res2) { return res2.products || []; })
      .catch(function () { return []; });
    fetch(RAIZ + 'recommendations/products.json?product_id=' + base + '&limit=8&intent=related')
      .then(function (r) { return r.json(); })
      .then(function (res) {
        var lista = res.products || [];
        return masVendido.then(function (l2) { return lista.concat(l2); });
      })
      .then(function (lista) {
        cache[base] = lista.map(ligero);
        // Se guarda mientras dura la visita: en las siguientes páginas aparecen al instante, sin volver a pedirlas
        try { sessionStorage.setItem('rc-sug2:' + base, JSON.stringify(cache[base])); } catch (e) {}
        if (firma === nueva) dibuja(cache[base], dentro);
      })
      .catch(function () {
        firma = '';
        var c3 = leerCajon();
        if (c3 && c3.caja.querySelector('.rc-sug__card--hueco')) c3.caja.innerHTML = '';
      });
  }

  // Al tocar AGREGAR el perfume aparece al instante en el carrito (igual que desde las tarjetas);
  // si Shopify no lo acepta, el carrito muestra lo real con el aviso (ya no se recarga la página)
  // Al agregar una sugerencia: si con ella se llega al envío gratis, nada de lo de arriba se mueve (las sugerencias se
  // cierran solas); si no, las sugerencias se quedan exactamente donde estaban, aunque a la lista le falte espacio para subir
  function acomodar(sc, caja, scroll0, y0) {
    if (!sc || !caja || !caja.isConnected) return;
    if ((parseInt(caja.getAttribute('data-falta'), 10) || 0) <= 0) { sc.scrollTop = scroll0; return; }
    var dy = caja.getBoundingClientRect().top - y0;
    if (dy < 1) return;
    var lista = caja.parentNode, extra = (parseFloat(lista.getAttribute('data-rc-relleno')) || 0) + dy;
    if (!lista.rcBase) lista.rcBase = getComputedStyle(lista).paddingBottom;
    lista.setAttribute('data-rc-relleno', extra);
    lista.style.paddingBottom = 'calc(' + lista.rcBase + ' + ' + extra + 'px)';
    sc.scrollTop += dy;
  }
  function quitarRelleno() {
    var l = document.querySelector('cart-drawer .rc-lista[data-rc-relleno]');
    if (l) { l.removeAttribute('data-rc-relleno'); l.style.paddingBottom = ''; }
  }
  // La ventanita de reseñas (Loox) no aparece encima del carrito abierto, aunque ya estuviera en pantalla o salga mientras
  // está abierto; al cerrarlo vuelve a salir como siempre (y se cierra como siempre)
  function ventanitas(ocultar) { document.body.classList.toggle('rc-carrito-abierto', !!ocultar); }
  function agregar(id, boton) {
    var c = cajon(), api = window.rcCarrito, tarjeta = boton.closest('.rc-sug__card'), foto = tarjeta && tarjeta.querySelector('.rc-sug__foto');
    var sc = c && c.querySelector('.rc-cuerpo'), caja = document.querySelector('[data-rc-sugeridos]');
    var scroll0 = sc ? sc.scrollTop : 0, y0 = caja ? caja.getBoundingClientRect().top : 0;
    window.rcAgregoTema = Date.now();
    if (api && api.agregarAlInstante({
      variante: id, producto: boton.getAttribute('data-producto'), cantidad: 1, marca: boton.getAttribute('data-marca'),
      nombre: boton.getAttribute('data-nombre'), tamano: boton.getAttribute('data-tamano'),
      precio: parseInt(boton.getAttribute('data-precio'), 10) || 0, antes: parseInt(boton.getAttribute('data-antes'), 10) || 0,
      foto: foto ? (foto.currentSrc || foto.src) : ''
    }, boton) === 'tope') return;
    acomodar(sc, caja, scroll0, y0);
    boton.disabled = true;
    // El carrito lo manda cuando le toca; si hay varios esperando, salen juntos en un solo pedido
    if (api && api.enFila) api.enFila({ variante: id, cantidad: 1, alFallar: function () { boton.disabled = false; } });
    else mandar(id, boton, c, api);
  }
  function mandar(id, boton, c, api) {
    var cuerpo = { items: [{ id: id, quantity: 1 }] };
    if (c && c.getSectionsToRender) {
      cuerpo.sections = c.getSectionsToRender().map(function (s) { return s.id; });
      cuerpo.sections_url = window.location.pathname;
    }
    fetch(RUTA_AGREGAR + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
      body: JSON.stringify(cuerpo)
    })
      .then(function (r) { return r.json().then(function (estado) { return { ok: r.ok, estado: estado }; }); })
      .then(function (res) {
        // Shopify lo aceptó: el carrito lo dibuja (o lo pide aparte si hace falta); nunca se toma como error
        if (res.ok) {
          if (api) return api.confirmar(res.estado);
          if (c && c.renderContents && res.estado.sections) c.renderContents(res.estado);
          return;
        }
        boton.disabled = false;
        if (api) api.fallo(res.estado);
      })
      .catch(function () { boton.disabled = false; if (api) api.fallo(null); });
  }
  // Un solo escucha para los botones AGREGAR, aunque la sección se vuelva a poner
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('cart-drawer .rc-sug__btn');
    if (b && !b.disabled) agregar(b.getAttribute('data-id'), b);
  });

  // Tarjetas de perfume (H8): la bolsa pasa a palomita cuando ese mismo tamaño ya está en el carrito, y regresa a la
  // bolsa al quitarlo. Al abrir la página ya vienen bien desde el servidor (snippets/card-product.liquid); aquí solo
  // se siguen los cambios del cajón, justo después de que se dibujan (no suma tiempo al toque)
  var marcaPendiente = false;
  function marcarLuego() {
    if (marcaPendiente) return;
    marcaPendiente = true;
    var luego = function () { setTimeout(marcarTarjetas, 0); };
    if (window.requestAnimationFrame) window.requestAnimationFrame(luego); else luego();
  }
  function marcarTarjetas() {
    marcaPendiente = false;
    var botones = document.querySelectorAll('.rc-bolsa[data-rc-var]');
    if (!botones.length) return;
    var en = {};
    [].forEach.call(document.querySelectorAll('cart-drawer .rc-item[data-variante]'), function (f) {
      var v = f.getAttribute('data-variante');
      if (v && !f.classList.contains('rc-item--saliendo')) en[v] = true;
    });
    [].forEach.call(botones, function (b) {
      var si = !!en[b.getAttribute('data-rc-var')];
      if (b.classList.contains('rc-bolsa--en') === si) return;
      b.classList.toggle('rc-bolsa--en', si);
      var t = b.closest('.rc'), n = t && t.querySelector('.rc__name');
      var cual = [n ? n.textContent.replace(/\s+/g, ' ').trim() : '', b.getAttribute('data-rc-tam') || ''].filter(Boolean).join(' ');
      b.setAttribute('aria-label', si ? 'En tu carrito: ' + cual + '. Agregar otra pieza' : 'Agregar ' + cual + ' al carrito');
    });
  }

  function observar() {
    var c = cajon();
    if (!c) return;
    new MutationObserver(function (cambios) {
      var propio = cambios.every(function (m) {
        var el = m.target.nodeType === 1 ? m.target : m.target.parentElement;
        return el && el.closest && el.closest('[data-rc-sugeridos]') && m.attributeName !== 'data-falta';
      });
      if (propio) return;
      var ab = abierto();
      if (ab !== observar.abierto) { observar.abierto = ab; ventanitas(ab); if (!ab) quitarRelleno(); }
      marcarLuego();
      reponer();
      clearTimeout(observar.pendiente);
      observar.pendiente = setTimeout(pintar, 60);
    }).observe(c, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'data-falta'] });
  }
  // Se empiezan a preparar en cuanto el cliente toca el ícono del carrito
  document.addEventListener('pointerdown', function (e) {
    if (e.target.closest && e.target.closest('#cart-icon-bubble')) pintar(true);
  }, { passive: true, capture: true });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', observar);
  else observar();
})();
/* Diagnóstico del carrito, SOLO en pruebas y SOLO si se abre una página con ?rc-diag=1 (se queda durante la visita;
   ?rc-diag=0 lo apaga). Muestra arriba a la izquierda cada toque, cada pedido a Shopify con lo que responde y lo que
   se ve en el carrito, para encontrar de dónde regresa un perfume borrado. Para los clientes no existe */
(function () {
  try {
    if (/[?&]rc-diag=1/.test(location.search)) sessionStorage.setItem('rc-diag', '1');
    if (/[?&]rc-diag=0/.test(location.search)) sessionStorage.removeItem('rc-diag');
    if (sessionStorage.getItem('rc-diag') !== '1') return;
  } catch (e) { return; }
  var t0 = Date.now(), lineas = [], panel = null, pedidos = 0;
  function pon(txt) {
    lineas.push(((Date.now() - t0) / 1000).toFixed(2) + ' ' + txt);
    if (lineas.length > 16) lineas.shift();
    if (!panel && document.body) {
      panel = document.createElement('div');
      panel.style.cssText = 'position:fixed;left:4px;top:4px;z-index:2147483647;max-width:94vw;background:rgba(0,0,0,.85);color:#8dffa8;font:10px/1.3 Menlo,monospace;padding:4px 6px;border-radius:6px;pointer-events:none;white-space:pre-wrap';
      document.body.appendChild(panel);
    }
    if (panel) panel.textContent = lineas.join('\n');
  }
  var f0 = window.fetch;
  window.fetch = function (u, o) {
    var url = String((u && u.url) || u);
    if (!/\/cart(\/|\.js)|sections=cart-drawer/.test(url)) return f0.apply(this, arguments);
    var n = ++pedidos, nom = url.replace(/^https?:\/\/[^/]+/, '').split('?')[0].replace('/cart/', '') + (/sections=/.test(url) ? ' (dibujo)' : '');
    var cuerpo = o && typeof o.body === 'string' ? o.body.replace(/,?"sections.*$/, '').slice(0, 70) : '';
    pon('→' + n + ' ' + ((o && o.method) || 'GET') + ' ' + nom + ' ' + cuerpo);
    return f0.apply(this, arguments).then(function (r) {
      r.clone().text().then(function (t) {
        var a = t.match(/"item_count":(\d+)/), b = t.match(/data-cuenta=\\?"(\d+)/);
        pon('←' + n + ' ' + r.status + ' artículos=' + (a ? a[1] : b ? b[1] : '?'));
      }).catch(function () {});
      return r;
    }, function (e) { pon('✗' + n + ' falló'); throw e; });
  };
  if (navigator.sendBeacon) {
    var b0 = navigator.sendBeacon.bind(navigator);
    navigator.sendBeacon = function (u, d) { if (/\/cart/.test(String(u))) pon('beacon ' + String(u).split('/').pop() + ' ' + String(d).slice(0, 60)); return b0(u, d); };
  }
  var visto = '', abiertoAntes = null;
  setInterval(function () {
    var c = document.querySelector('cart-drawer');
    if (!c) return;
    var ab = c.classList.contains('active');
    if (ab !== abiertoAntes) { abiertoAntes = ab; pon(ab ? 'carrito abierto' : 'carrito cerrado'); }
    var filas = [].map.call(c.querySelectorAll('.rc-lista .rc-item:not(.rc-item--saliendo)'), function (f) {
      return ((f.querySelector('.rc-item__nombre') || {}).textContent || '').trim().slice(0, 11) + (f.hasAttribute('data-clave') ? '' : '*');
    });
    var k = filas.length + ': ' + filas.join(', ');
    if (k !== visto) { visto = k; pon('se ve ' + k); }
  }, 50);
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('cart-drawer .rc-quitar, cart-drawer .rc-cantidad__btn, cart-drawer .rc-sug__btn');
    if (!b) return;
    var f = b.closest('.rc-item, .rc-sug__card'), nom = f && ((f.querySelector('.rc-item__nombre, .rc-sug__nombre') || {}).textContent || '');
    pon('toque ' + (b.classList.contains('rc-quitar') ? 'borrar' : b.classList.contains('rc-sug__btn') ? 'agregar' : b.name) + ' ' + (nom || '').trim().slice(0, 14));
  }, true);
  // Ventanitas fijas de otras apps (para encontrar la de reseñas)
  setInterval(function () {
    [].forEach.call(document.querySelectorAll('body *'), function (el) {
      if (el.rcVisto || el === panel || el.closest('cart-drawer')) return;
      var cs = getComputedStyle(el);
      if (cs.position !== 'fixed' || el.offsetWidth > 420 || el.offsetHeight < 30) return;
      el.rcVisto = true;
      var cl = typeof el.className === 'string' ? el.className.slice(0, 40) : '';
      pon('fija <' + el.tagName.toLowerCase() + (el.id ? ' id=' + el.id.slice(0, 30) : '') + (cl ? ' class=' + cl : '') + (el.shadowRoot ? ' sombra' : '') + '>');
    });
  }, 2000);
  pon('diagnóstico encendido');
})();
